import { useMutation } from "@tanstack/react-query";
import { httpRequest } from "@/lib";

const TEMPLATE_FILENAME = "colaboradores_template.csv";

// The template comes from the API with one fictitious row (SCRUM-60); the
// modal used to build an inline CSV with real-looking people in it.
async function downloadEmployeeImportTemplate(): Promise<void> {
  const response = await httpRequest.get("/employees/import/template", {
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(
    new Blob([response.data], { type: "text/csv;charset=utf-8;" })
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", TEMPLATE_FILENAME);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export function useDownloadEmployeeImportTemplateMutation() {
  return useMutation({ mutationFn: downloadEmployeeImportTemplate });
}
